import { apiFetch } from './apiClient';

/* Tabelas oficiais da NFS-e Nacional (Anexo B — NBS 2.0 e lista de serviço
   nacional; Anexo C — indicador de operação do IBS/CBS). Ficam no backend
   porque é lá que a emissão valida: código que não consta na tabela não
   entra na nota. */

export function buscarTabelaFiscal(tabela, { busca, limite } = {}) {
  const q = new URLSearchParams();
  if (busca) q.set('busca', busca);
  if (limite) q.set('limite', limite);
  return apiFetch(`/tabelas-fiscais/${tabela}${q.toString() ? `?${q}` : ''}`);
}

export const listarIndicadoresOperacao = () => apiFetch('/tabelas-fiscais/indop');
